<template>
  <div class="bgc head">
    <div class="box_l">
      <div class="stock-price-info">
        <notice-bar>
          <span>要深入践行守望相助理念，深化民族团结进步教育，铸牢中华民族共同体意识，促进各民族像石榴籽一样紧紧抱在一起，共同守卫祖国边疆、共同创造美好生活</span>
        </notice-bar>
      </div>
    </div>
    <div class="box"><span>湖南省民族地区乡村文化大数据服务平台</span></div>

    <div class="box_r" v-show="this.$route.path != '/'">
      <span>{{ headTxt }}</span>
    </div>

    <div class="box_r" v-show="this.$route.path == '/'">
      <span @click="textShow = true">{{ headTxt.title }}</span>
    </div>

    <el-dialog
      title="关于我们"
      :visible.sync="textShow"
      width="30vw"
      :append-to-body="true"
    >
      <span>{{ headTxt.txt }}</span>
    </el-dialog>
  </div>
</template>

<script>
import NoticeBar from "./NoticeBar.vue";

export default {
  components: { NoticeBar },
  props: {
    headTxt: "",
  },
  data() {
    return {
      input: "",
      textShow: false,
    };
  },
  mounted() {},
  methods: {
    textShow() {},
  },
};
</script>

<style lang="less" scoped>
.head {
  display: flex;
  height: 6vh;
  width: 100%;
  // background-color: pink;

  .box_l,
  .box,
  .box_r {
    flex: 1;
  }

  .box_l {
    margin: auto;

    .stock-price-info {
      margin: auto 1vw;
      width: 120%;
      height: 4vh;
      padding: 0 16px;
      font-size: calc(100vw * 20 / 1920);
    }

    .box_l_input {
      margin-left: 5%;
    }
    /deep/ .el-input__inner {
      // margin-left: 5%;
      height: 4vh;
      font-size: calc(100vw * 20 / 1920);
    }
  }

  .box {
    flex: 2;
    text-align: center;
    margin: auto;
    font-size: calc(100vw * 30 / 1920);
    color: #000;
    font-weight: 1000;
    font-family: "黑体";
  }

  .box_r {
    margin: 1.5vh 1%;
    text-align: right;
    font-weight: 700;
    cursor: pointer;
    font-size: calc(100vw * 24 / 1920);
  }
  .box_r:hover {
    color: rgb(30, 116, 255);
    font-weight: 700;
  }
}

/deep/ .el-dialog__body {
  font-size: calc(100vw * 20 / 1920) !important;
}
</style>